import React from 'react'
import PlansAndPricingContainer from '../../../Components/settings/PlansAndPricingComponent/PlansAndPricings'

export default function PlansAndPricingPage() {
    return (
        <div className='page-body'>
            <PlansAndPricingContainer />
        </div>
    )
}
